// Import de bibliotecas principais
import React, { useState, useRef } from 'react'
import { useMediaQuery } from 'react-responsive'
import ReactPlayer from 'react-player'

// Import de elementos de estilização, componentes gerais e de layout
import { motion } from 'framer-motion/dist/framer-motion'

import './Video.scss'

export function Video({ data }) {
	const isMobile = useMediaQuery({ query: '(max-width: 1000px)' })
	const [loading, setLoading] = useState(true)
	const [playing, setPlaying] = useState(true)
	const video = useRef()

	const isIOSorMac = /Mac|iPod|iPad/.test(navigator.platform)

	return (
		<motion.section
			className="video"
			style={isIOSorMac ? { background: '#00006a' } : {}}
		>
			{isMobile ? (
				<video
					autoPlay
					playsInline
					muted
					loop
					className="video__desktop"
					src={data.videoMobile}
					type="video/mp4"
				></video>
			) : (
				<ReactPlayer
					url={data.video}
					muted={true}
					volume={0}
					playing={playing}
					ref={video}
					playsinline={true}
					progressInterval={250}
					loop={true}
					onPlay={() => setLoading(false)}
					onProgress={e => {
						if (
							e.playedSeconds > e.loadedSeconds - 0.3 &&
							e.playedSeconds != 0
						) {
							video.current.seekTo(0, 'fraction')
							setPlaying(true)
						}
					}}
					style={loading ? { opacity: 0 } : { opacity: 1 }}
				/>
			)}
		</motion.section>
	)
}
